export const STATUS = {
  PENDING: 0,   // ⏳ منتظر
  ACTIVE: 1,    // ✅ مفعل
  BLOCKED: 2,   // ⛔ موقوف
  CANCELLED: 3, // 🚫 ملغي
};
